// Execute
document.addEventListener('DOMContentLoaded', function(){
    startApp();
});

function startApp(){
    nextPg();
    addContent();
}

// Index content

// Add the content
function addContent(){
    const index = document.querySelector('.index');

    const btn = document.createElement('DIV');

    btn.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-menu-2" width="48" height="48" viewBox="0 0 24 24" stroke-width="2" stroke="#00FF4D" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <line x1="4" y1="6" x2="20" y2="6" />
        <line x1="4" y1="12" x2="20" y2="12" />
        <line x1="4" y1="18" x2="20" y2="18" />
    </svg>
    `;

    btn.classList.add('index__button');  
    index.appendChild(btn); 
    
    btn.onclick = function (){

        // Remove the button to open
        btn.remove();

        const style = document.querySelector('.with-aside');
        style.classList.add('index__style');

        // Add the button to close
        const closeBtn = document.createElement('DIV');
        closeBtn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-menu-2" width="48" height="48" viewBox="0 0 24 24" stroke-width="2" stroke="#00FF4D" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <line x1="4" y1="6" x2="20" y2="6" />
            <line x1="4" y1="12" x2="20" y2="12" />
            <line x1="4" y1="18" x2="20" y2="18" />
        </svg>
        `;

        // Remove the index content and the button to close, add the button to open
        closeBtn.onclick = function(){
            content.remove();
            closeBtn.remove();
            index.appendChild(btn); 
            style.classList.remove('index__style');
        }


        const content = document.createElement('DIV');

        // Content to add
        content.innerHTML=`
        <h2 class="index__title">Tabla de contenido</h2>
        <ul class="reset-list index__list">
            <a href="#"><li class="text text--index">Prólogo</li></a>
            <a href="#"><li class="text text--index">Capitulo 1</li></a>
                <li>
                    <ul>
                        <a href="#"><li class="text text--index">Inicio</li></a>
                        <a href="#"><li class="text text--index">Mitad</li></a>
                        <a href="#"><li class="text text--index">Final</li></a>
                    </ul>
                </li>
            <a href="#"><li class="text text--index">Capitulo 2</li></a>
            <li>
                <ul>
                    <a href="#"><li class="text text--index">Inicio</li></a>
                    <a href="#"><li class="text text--index">Mitad</li></a>
                    <a href="#"><li class="text text--index">Final</li></a>
                </ul>
            </li>
            <a href="#"><li class="text text--index">Capitulo 3</li>
            <li>
                <ul>
                    <a href="#"><li class="text text--index">Inicio</li></a>
                    <a href="#"><li class="text text--index">Mitad</li></a>
                    <a href="#"><li class="text text--index">Final</li></a>
                </ul>
            </li>
            <a href="#"><li class="text text--index">Fase final</li></a>
        </ul> 
        `;

        content.classList.add('index__content');
        index.appendChild(closeBtn); 
        index.appendChild(content);
    }   
}


// Change Page

// Next Page
function nextPg(){
    const changePg = document.querySelector('.change-pg');

    const arrow = document.createElement('DIV');

    arrow.innerHTML = `
        <p class="text text--change-pg">Siguiente</p>
        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-narrow-right" width="100" height="100" viewBox="0 0 24 24" stroke-width="3" stroke="#00FF4D" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <line x1="15" y1="16" x2="19" y2="12" />
                        <line x1="15" y1="8" x2="19" y2="12" />
        </svg>
    `;
    
    arrow.classList.add('change-pg__content');
    

    arrow.onclick = function(){
        arrow.remove();
        changePg.classList.add('after-nextPg');
        changePg.classList.remove('after-prePg');

        prePg(); 
    }

    changePg.appendChild(arrow);
}

// Previous Page
function prePg(){
    const changePg = document.querySelector('.change-pg');

    const arrow = document.createElement('DIV');

    arrow.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-narrow-left" width="100" height="100" viewBox="0 0 24 24" stroke-width="3" stroke="#00FF4D" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <line x1="5" y1="12" x2="19" y2="12" />
        <line x1="5" y1="12" x2="9" y2="16" />
        <line x1="5" y1="12" x2="9" y2="8" />
    </svg>
    <p class="text text--change-pg">Anterior</p>
    `;

    arrow.classList.add('change-pg__content');
    

    arrow.onclick = function(){
        arrow.remove();
        changePg.classList.add('after-prePg');
        changePg.classList.remove('after-nextPg');

        nextPg();
    }

    changePg.appendChild(arrow)
}